import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {ApiCallOptions} from '../types';
import type {
    ApiResponseWrapper,
    ApiResponseWrapperFieldView,
    ApiResponseWrapperListFieldView,
    FieldUpdateRequest,
    FieldCreateRequest,
    FieldFillRequest,
    FieldView
} from './api.d';

export type {FieldView};

export const getField = (transactionId: string, documentId: string, approvalId: string, fieldId: string, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperFieldView>(SERVICE_NAMES.FIELD, 'GET', `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}`)({
    ...options
});

export const updateField = (transactionId: string, documentId: string, approvalId: string, fieldId: string, data: FieldUpdateRequest, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperFieldView>(SERVICE_NAMES.FIELD, 'PUT', `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}`)({
    data,
    ...options
});

export const deleteField = (transactionId: string, documentId: string, approvalId: string, fieldId: string, options: ApiCallOptions = {}) => createApiCall<void>(SERVICE_NAMES.FIELD, 'DELETE', `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}`)({
    ...options
});

export const fillField = (transactionId: string, documentId: string, approvalId: string, fieldId: string, data: FieldFillRequest, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperFieldView>(SERVICE_NAMES.FIELD, 'PUT', `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields/${fieldId}/fill`)({
    data,
    ...options
});

export const getFieldsForApproval = (transactionId: string, documentId: string, approvalId: string, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperListFieldView>(SERVICE_NAMES.FIELD, 'GET', `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields`)({
    ...options
});

export const createField = (transactionId: string, documentId: string, approvalId: string, data: FieldCreateRequest, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperFieldView>(SERVICE_NAMES.FIELD, 'POST', `transactions/${transactionId}/documents/${documentId}/approvals/${approvalId}/fields`)({
    data,
    ...options
});

export const cloneFields = (transactionId: string, sourceDocumentId: string, targetDocumentId: string, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperListFieldView>(SERVICE_NAMES.FIELD, 'POST', `transactions/${transactionId}/documents/${sourceDocumentId}/fields/clone-to/${targetDocumentId}`)({
    ...options
});

export const getFieldsForDocument = (transactionId: string, documentId: string, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperListFieldView>(SERVICE_NAMES.FIELD, 'GET', `transactions/${transactionId}/documents/${documentId}/approvals/fields`)({
    ...options
});

export const getFieldsForTransaction = (transactionId: string, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperListFieldView>(SERVICE_NAMES.FIELD, 'GET', `transactions/${transactionId}/fields`)({
    ...options
});

export const getFieldsForRecipientInDocument = (transactionId: string, documentId: string, recipientId: string, options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapperListFieldView>(SERVICE_NAMES.FIELD, 'GET', `transactions/${transactionId}/documents/${documentId}/recipients/${recipientId}/fields`)({
    ...options
});

export const getValidationTypes = (options: ApiCallOptions = {}) => createApiCall<ApiResponseWrapper<string[]>>(SERVICE_NAMES.FIELD, 'GET', 'fields/validation-types')({
    ...options
});

export const fieldApi = {
    getField,
    updateField,
    deleteField,
    fillField,
    getFieldsForApproval,
    createField,
    cloneFields,
    getFieldsForDocument,
    getFieldsForTransaction,
    getFieldsForRecipientInDocument,
    getValidationTypes
};
